/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-12 10:40:09
 * @LastEditTime: 2025-02-25 10:28:02
 * @LastEditors: ywj@originqc.com
 */
import React from 'react'
import defaultIcon from '@/assets/css/imgs/skeleton.png'
import './index.scss';
interface IDefault{ 
  width:number,
  height: number
  background?:string
}
const DefaultFill:React.FC<IDefault>=(props)=> {
  return (
    <div className='default-fill-container' style={{width:props.width,height:props.height,background:props.background||'rgba(240, 242, 245, 1)'}}>
      <img src={defaultIcon } alt="default" />
    </div>
  )
}

export default DefaultFill;